export default __webpack_public_path__ + "static/media/noCreditRequired.0ef11fde.png";